import state from "./merchantGlobalSettingState";
import mutations from "./merchantGlobalSettingMutation";
import actions from "./merchantGlobalSettingActions";
import getters from "./merchantGlobalSettingGetters.js";

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};
